const state = () => ({
  dashboardStats: null,
  statusSummary: null,
  periods: { data: [], loading: false, pagination: { total: 0 } },
  currentPeriod: null,
  wizard: {
    step: 1,
    mode: "create",
    periodId: null,
    formData: { step1: {}, step2: {}, step3: {}, step4: {} },
    validation: { step1: false, step2: false, step3: false, step4: false },
    isDirty: false,
  },
  runs: { data: [], loading: false, pagination: { total: 0 } },
  currentRun: null,
  runResults: { data: [], loading: false, pagination: { total: 0 } },
  runProgress: null,
  pollingInterval: null,
  pollingTimedOut: false,
  currentEntity: null,
  entityHistory: { data: [], loading: false, total: 0 },
  entityLiveData: null,
  scoreChangeRequests: [],
  scoreChangeDialog: false,
  resultModal: { open: false, resultId: null, data: null },
  responseCodes: [],
  toast: null,
});

export default state;
